import PanelTemplate from '../../html/components/panel.html'
import PanelHeaderTemplate from '../../html/components/panel-header.html'
import PanelContentTemplate from '../../html/components/panel-content.html'

import Component from '../shared/component'

export const Panel = Component('v-panel', {
  template: PanelTemplate
})

export const PanelHeader = Component('v-panel-header', {
  template: PanelHeaderTemplate
})

export const PanelContent = Component('v-panel-content', {
  template: PanelContentTemplate
})
